<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-evgImport-lcInventory',
  components: { PageTable },
}
</script>
